// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2025-09-23T10:09:28+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  189666
//    Project:        510
//    Environment:    3832 - master
//    MD5:            572227ca97cb077f81c1445d3232f151
//    Signature:      eyJpdiI6IkhkeTBSc3pwTzMzdVQ5SUFhQ0ZQckE9PSIsInZhbHVlIjoiRTBVN3h4VFB5Nm5ueGxwTEp3VWYwRFFhQWxMN2xwUUoyYzFydUcyRUtQblZ0SlwvbjRzc1pYNm1NbGlENzQ0YW9YTXhJVlc1ZW5aQTc5Um1ySHdwT2FFSVYwT0pTaFliS21udm5lcHE0cGxiWHUwa0hFT1lNdTdCb2dCU3B2d1JkS2ZcL0pkNjhXVzNaS0xROURQK09sdDBpQ1V4MzdnWG1Lc1pDUzlBNEdjUzg5bGZna21nWHBHb2hTYklYWGFRT3pxMGdaYkdtY0RkdEZOS2RzbXFvMG5GcUFkcDRDblhzZEt1TlppWFFJUmdQaEh5bmRWemJsSlFmYWNPV3hoMTZOZXZRZ0VYdXZaNmE4YzlZK09PZnF2WnMycmhGV1JHYmhTRW5yMU95RDhtWGlldWk0bDZFektcL2drXC9DaEFXcnZONkdpN1RRZHFaQm1zdTdrekxtWUthZHViMFh2Z1IwNno5TDRHckhmbk9EN21uQkZiYjFFVkRRNngrbytrQUhmS0ExRk1nV1VZaTdtckEwWTh0Qm9NOXc9PSIsIm1hYyI6ImExNzA2YjYzNmJmNTE2Mzc5OTRiMTM1ZDQ2ZGI2YzNhY2Y1YTZjMDJhYzc3ZjU1MmRhMzUzN2I0MWU2ZGY4NzkifQ==
document.addEventListener('DOMContentLoaded', () => {
  const buttons = document.querySelectorAll('button[data-ref="childParent"]');

  if (!buttons.length) return;

  buttons.forEach((button) => {
    button.addEventListener('click', (e) => {
      e.preventDefault();

      setTimeout(() => {
        const activeList = document.querySelector(
          '.mobile-menu__navlist.mobile-menu__navlist__child.is-active'
        );
        if (activeList) {
          activeList.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 1000);
    });
  });
});
